import { useLocation, useNavigate } from 'react-router-dom';

export const useSmoothScroll = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const handleNavClick = (targetId: string) => {
    if (location.pathname === '/') {
      document.getElementById(targetId)?.scrollIntoView({ behavior: 'smooth' });
    } else {
      navigate('/', { state: { scrollTo: targetId } });
    }
  };

  return { handleNavClick };
};